import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "message-sent",
  "data-aos": "slide-up",
  "data-aos-easing": "ease"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Thank you! I will get back to you soon!", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  class: "follow-me",
  "data-aos": "slide-up",
  "data-aos-easing": "ease"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Want to connect?", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Resume link:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactMe = _resolveComponent("ContactMe")!
  const _component_ConnectTag = _resolveComponent("ConnectTag")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createVNode(_Transition, {
      name: "slide-fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (!_ctx.messageSent)
          ? (_openBlock(), _createBlock(_component_ContactMe, {
              key: 0,
              "form-submitted": _ctx.setMessageSent
            }, null, 8, ["form-submitted"]))
          : (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
      ]),
      _: 1
    }),
    _createElementVNode("section", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialContent, (tag, index) => {
          return (_openBlock(), _createBlock(_component_ConnectTag, {
            icon: tag.icon,
            key: index,
            link: tag.link,
            name: tag.name
          }, null, 8, ["icon", "link", "name"]))
        }), 128)),
        _createVNode(_component_ConnectTag, {
          icon: "https://raw.githubusercontent.com/feathericons/feather/master/icons/mail.svg",
          link: _ctx.mailLink,
          name: _ctx.Email
        }, null, 8, ["link", "name"])
      ]),
      _hoisted_6,
      _createVNode(_component_ConnectTag, {
        link: _ctx.resumeTag,
        icon: "https://raw.githubusercontent.com/feathericons/feather/master/icons/file-text.svg",
        name: "Resume"
      }, null, 8, ["link"])
    ])
  ]))
}